import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { rgba } from '@savgroup-front-common/primitive/helpers/cssColor';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

import { fontStyle } from '../../../theme/helpers/fontStyle';

interface $RouteSubTabProps {
  $isActive: boolean;
}
export const $RouteSubTab = styled.div<$RouteSubTabProps>`
  @media ${media.maxWidth.xs} {
    &&& {
      ${fontStyle('base')};
    }
  }

  display: flex;
  color: ${({ theme }) => theme.colors.mainTextColor}!important;
  ${fontStyle('xl')};
  font-weight: ${({ $isActive }) =>
    $isActive ? fontWeight('bold') : fontWeight('normal')};

  position: relative;
  cursor: pointer;
  padding-bottom: ${spacing('xl')};

  &:hover,
  &:focus {
    outline: 0;
    color: ${({ theme }) => theme.colors.primary}!important;
    text-decoration: unset;
    svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

interface $SubMenuLinkCustomProps {
  $isActive: boolean;
}

export const $SubMenuLinkCustom = styled(Link)<$SubMenuLinkCustomProps>`
  padding-left: ${spacing('lg')};
  padding-right: ${spacing('lg')};
  text-align: left;
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.primary : theme.colors.darkBackground};
  background-color: ${({ theme, $isActive }) =>
    $isActive ? rgba(theme.colors.primary, 0.05) : 'transparent'};
  width: 100%;
  height: ${spacing(10)};
  ${fontStyle('sm')};
  border: 0;
  display: flex;
  align-items: center;
  font-weight: ${fontWeight('medium')};
  outline: 0;
  white-space: nowrap;
  min-width: ${rem(196)};
  cursor: pointer;
  border-radius: ${({ $isActive, theme }) =>
    $isActive ? theme.tw.radius.lg : null};
  svg {
    width: ${spacing(5)};
    height: ${spacing(5)};
    margin-right: ${spacing(2.5)};
  }

  &:focus,
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => rgba(theme.colors.primary, 0.03)};
    border-radius: ${({ theme }) => theme.tw.radius.lg};
  }
`;

export const $SubTabMessageWithIcon = styled.div`
  align-items: center;
  display: flex;
  svg {
    margin-right: ${spacing(1.5)};
    color: ${({ theme }) => theme.colors.primary};
  }

  &:hover {
    svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const $SubTabMessage = styled.div`
  margin-top: ${spacing('xs')};
  ${fontStyle('sm')};
  font-weight: ${fontWeight('normal')};
`;

export const $IconMargin = styled.div`
  margin-left: ${spacing(1.5)};
  display: flex;

  svg:first-child {
    color: ${({ theme }) => theme.colors.paragraphTextColor};
  }
`;
